import SMConst from 'frontend_core/dist/constants/sm-const'
import Path from 'routes/path'
import { type State as ReservationDetailState } from 'redux/modules/reservationDetail'
import { getReservationChangeRequestBlockProps } from 'components/molecules/ReservationChangeRequestBlock/presenter'
import { getReservationGetPointBlockProps } from 'components/molecules/ReservationGetPointBlock/presenter'
import { getReservationAdditionalFeeBlockProps } from 'components/molecules/ReservationAdditionalFeeBlock/presenter'

export function getReservationChangeHostFormProps(
  reservationDetail: ReservationDetailState,
  onClickBackToMessage: Function,
  onClickApprove: Function,
  onClickDenial: Function,
) {
  const { detail } = reservationDetail
  const unapproved = detail.unapproved_reservation || {}
  const reservationChangeRequestBlockProps = getReservationChangeRequestBlockProps(
    detail,
    unapproved,
  )

  return {
    reservationChangeRequestBlockProps,
    reservationGetPointBlockProps: getReservationGetPointBlockProps(
      detail,
      unapproved,
    ),
    reservationAdditionalFeeBlockProps: getReservationAdditionalFeeBlockProps(
      detail,
      reservationChangeRequestBlockProps.billStatementProps.additionalFee,
      unapproved,
    ),
    onClickBackToMessage: onClickBackToMessage,
    onClickDenial: onClickDenial,
    onClickApprove: onClickApprove,
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationChangeHostForm/presenter.js